// https://vuex.vuejs.org/en/mutations.html
import NotificationService from "@/services/hmd/NotificationService"
import { uniqueId } from "lodash"
export default {
  clearSession(state) {
    state.user = null
  },
  setGlobalBrandWithId(state, id) {
    const b = state.brands.find(o => o.id === id)
    state.globalBrand = b
    state.catalogFilters.brand_id = [b]
  },
  setGlobalBrand(state, b) {
    state.globalBrand = b
    state.catalogFilters.brand_id = [b]
  },
  setBrands(state, bs) {
    state.brands = bs
  },
  setBrand(state, b) {
    state.brand = b
  },
  clearDrawerFilters(state) {
    state.catalogFilters = {
      ...state.catalogFilters,
      category: "",
      product_type: "",
      discontinued: "",
      gender: "",
      status: "",
      validated: "",
      launched_at: "",
      discontinued_at: ""
    }
  },
  setBrandsFiltersValue(state, o) {
    state.brandsFilters[o.attr] = o.value
  },
  setCatalogFiltersValue(state, o) {
    state.catalogFilters[o.attr] = o.value
  },
  setUser(state, user) {
    state.user = user
    // router.push({ name: "Accueil" })
  },
  setFiltersDrawerExpanded(state, v) {
    state.filtersDrawerExpanded = v
    localStorage.setItem(
      "filtersDrawerExpanded",
      JSON.stringify(state.filtersDrawerExpanded)
    )
  },
  setNotifications(state) {
    NotificationService.list(this).then(r => {
      state.notifications = r.all_list || []
    })
  },
  error(state, ml) {
    return state.errors.push({
      id: uniqueId(),
      text: ml.msg,
      color: ml.color,
      isVisible: true,
      createdAt: new Date().getTime(),
      timeout: 3000
    })
  },
  success(state, msg) {
    return state.errors.push({
      id: uniqueId(),
      text: msg,
      color: "success",
      isVisible: true,
      createdAt: new Date().getTime(),
      timeout: 3000
    })
  },
  warning(state, msg) {
    return state.errors.push({
      id: uniqueId(),
      text: msg,
      color: "warning",
      isVisible: true,
      createdAt: new Date().getTime(),
      timeout: 3000
    })
  },
  markAllNotificationsAsSeen(state) {
    state.notifications.map(n => {
      n.seen = true
    })
  },
  notify(state, n) {
    return state.notifications.push({
      id: uniqueId(),
      message: n,
      seen: false,
      createdAt: new Date().getTime()
    })
  },
  online(state) {
    state.isOnline = true
  },
  offline(state) {
    state.isOnline = false
  },
  "loading-route-start": state => {
    state.loading.route = true
  },
  "loading-route-end": state => {
    // delay for animation
    setTimeout(() => {
      state.loading.route = false
    }, 300)
  },
  "loading-request-start": state => {
    state.loading.request = true
  },
  "loading-request-end": state => {
    state.loading.request = false
  }
}
